module.exports = __webpack_public_path__ + "static/media/benefits9.cb8d981f.jpg";